import { render, staticRenderFns } from "./IDVerifForm.vue?vue&type=template&id=d065e93a&scoped=true&"
import script from "./IDVerifForm.vue?vue&type=script&lang=js&"
export * from "./IDVerifForm.vue?vue&type=script&lang=js&"
import style0 from "./IDVerifForm.vue?vue&type=style&index=0&id=d065e93a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065e93a",
  null
  
)

export default component.exports